/**
 * Canonical transaction type constants. Single source of truth for all transaction types.
 * Use these everywhere instead of string literals. Compose sets from these for filters, etc.
 */

export const BUY = 'Buy';
export const SELL = 'Sell';
export const REINVESTMENT = 'Reinvestment';
export const SPLIT = 'Split';
export const STOCK_TRANSFER = 'Stock Transfer';

export const DEPOSIT = 'Deposit';
export const WITHDRAW = 'Withdraw';
export const DIVIDEND = 'Dividend';
export const CASH_TRANSFER = 'Cash Transfer';
export const FEE = 'Fee';
export const INTEREST = 'Interest';

/** Trade types that add to position (buy-like). */
export const BUY_LIKE_TYPES = [BUY, REINVESTMENT, SPLIT, STOCK_TRANSFER];

/** All cash transaction types (for filters, dropdowns, includes checks). */
export const CASH_LIKE_TYPES = [DEPOSIT, WITHDRAW, DIVIDEND, CASH_TRANSFER, FEE, INTEREST];

/** All stored trade types. */
export const TRADE_TYPES = [BUY, SELL, REINVESTMENT, SPLIT, STOCK_TRANSFER];

/** Filter pill values shown in UI. */
export const TRADE_FILTER_PILLS = [BUY, SELL, REINVESTMENT, SPLIT, STOCK_TRANSFER];
